import React from 'react';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, number } from 'prop-types';
import PaymentHoldDetailsListItem from './PaymentHoldDetailsListItem';
import Hint from '../Hint/Hint';
import { FMessage } from '../../hoc/IntlComponents';
import { prettifyAmount } from '../../utils/utils';

const propTypes = {
  details: array.isRequired,
  amount: number,
};

const defaultProps = {
  details: [],
  amount: 0,
};

const getCurrency = detail => (detail ? detail.currency : null);

const PaymentHoldDetailsList = ({ details, amount, emptyTable, tableSettings }) => {
  return (
    <Table className="hold-details-table no-margin" responsive bordered>
      <thead>
        {tableSettings ? <tr>
          {tableSettings.created && <th>
            <FormattedMessage id="payments.hold.created" defaultMessage="Created" />
          </th>}
          {tableSettings.accepted && <th>
            <FormattedMessage id="payments.hold.accepted" defaultMessage="Accepted" />
          </th>}
          {tableSettings.flow && <th>
            <FormattedMessage id="payments.hold.flow" defaultMessage="Flow" />
          </th>}
          {tableSettings.offer && <th>
            <FormattedMessage id="payments.hold.offer" defaultMessage="Offer" />
          </th>}
          {tableSettings.transfer && <th>
            <FormattedMessage id="payments.hold.transfer" defaultMessage="Transfer to balance" />
          </th>}
          {tableSettings.amount && <th className="text-right">
            <FormattedMessage id="payments.hold.amount" defaultMessage="Amount" />
          </th>}
        </tr>
          :
          <tr>
            <th>
              <FormattedMessage id="payments.hold.created" defaultMessage="Created" />
            </th>
            <th>
              <FormattedMessage id="payments.hold.accepted" defaultMessage="Accepted" />
            </th>
            <th>
              <FormattedMessage id="payments.hold.flow" defaultMessage="Flow" />
            </th>
            <th>
              <FormattedMessage id="payments.hold.offer" defaultMessage="Offer" />
            </th>
            <th>
              <FormattedMessage id="payments.hold.transfer" defaultMessage="Transfer to balance" />
            </th>
            <th className="text-right">
              <FormattedMessage id="payments.hold.amount" defaultMessage="Amount" />
            </th>
          </tr>}
      </thead>

      <tbody>
        {emptyTable ?
          <tr>
            <td colSpan={6} className='text-center'>
              <div className='card-empty'>
                <FormattedMessage id="payments.no_payments" defaultMessage="No Payments" />
              </div>
            </td>
          </tr>
          : details.map((detail, i) => (
            <PaymentHoldDetailsListItem tableSettings={tableSettings && tableSettings} {...detail} key={i} />
          ))}
      </tbody>

      {!emptyTable && <tfoot className="tfoot-dark">
        <tr>
          <td colSpan="5">
            <FormattedMessage id="payments.hold.holding-amount" defaultMessage="Holding amount" />
          </td>
          <td className="text-right text-nowrap">
            {prettifyAmount(amount)}
            &nbsp;
            {getCurrency(details[0])}
            <Hint id='payments-hold-total-hint' popoverClassName="payments-hold-total-popover">
              <FMessage id='payments.hold.total.hint' />
            </Hint>
          </td>
        </tr>
      </tfoot>}
    </Table>
  );
};

PaymentHoldDetailsList.propTypes = propTypes;
PaymentHoldDetailsList.defaultProps = defaultProps;

export default PaymentHoldDetailsList;
